module.exports = __webpack_public_path__ + "static/media/virtual-presenter.64a0d81d.svg";